import { render, staticRenderFns } from "./ProjectSummaryCredits.vue?vue&type=template&id=3c3514e5"
import script from "./ProjectSummaryCredits.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports